module.exports = __webpack_public_path__ + "static/media/Fleur Delacour 3.97f48d12.jpg";